var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 3.33317C7.7363 3.33317 8.33325 2.73622 8.33325 1.99984C8.33325 1.26346 7.7363 0.666504 6.99992 0.666504C6.26354 0.666504 5.66659 1.26346 5.66659 1.99984C5.66659 2.73622 6.26354 3.33317 6.99992 3.33317Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66659 3.33317C2.40297 3.33317 2.99992 2.73622 2.99992 1.99984C2.99992 1.26346 2.40297 0.666504 1.66659 0.666504C0.930206 0.666504 0.333252 1.26346 0.333252 1.99984C0.333252 2.73622 0.930206 3.33317 1.66659 3.33317Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 3.33317C13.0696 3.33317 13.6666 2.73622 13.6666 1.99984C13.6666 1.26346 13.0696 0.666504 12.3333 0.666504C11.5969 0.666504 10.9999 1.26346 10.9999 1.99984C10.9999 2.73622 11.5969 3.33317 12.3333 3.33317Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.764f6984.svg";
export { ForwardRef as ReactComponent };